import { Loader2 } from "lucide-react";
import { cn } from "../lib/utils";
import { useI18n } from "../hooks/useI18n";

interface LoadingSpinnerProps {
  className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  const { t } = useI18n();

  return (
    <div
      className={cn(
        "flex min-h-[120px] flex-col items-center justify-center gap-3 p-6",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="size-8 animate-spin text-muted-foreground" aria-hidden="true" />
      <span className="sr-only">{t("common.loading")}</span>
    </div>
  );
}
